import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-terms';

const getCustomerTermList = async ({
  companyHeadquarterId,
  customerId,
  page,
  limit,
  search,
  orderBy
}) => {
  const method = 'GET';
  const url =
    `${USE_CASE_URL}` +
    `?companyHeadquarterId=${companyHeadquarterId}&headquarterCustomerId=${customerId}&page=${page}&limit=${limit}&search=${search}&orderBy=${orderBy}`;

  const json = await request({ method, url });
  return json;
};

export default getCustomerTermList;
